var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundsquares3Install(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1540,
    height: 1344,
    viewBox: "0 0 1540 1344",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_612_858)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1920V1344H0V0Z",
    fill: "#0C0C11"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_612_858",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1920,
    height: 1344
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1920V1344H0V0Z",
    fill: "url(#paint0_radial_612_858)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_612_858)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H128V128H0V0Z",
    fill: "#404249",
    fillOpacity: 0.34902,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.999 0H255.999V128H127.999V0Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.001 0H384.001V128H256.001V0Z",
    fill: "#404249",
    fillOpacity: 0.462745,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 0H512V128H384V0Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.999 0H639.999V128H511.999V0Z",
    fill: "#404249",
    fillOpacity: 0.819608,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.001 0H640.001V128H768.001M768.001 0V128M768.001 0H896M768.001 128H896M896 0V128M896 0H1024V128H896",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024 0H1152V128H1024V0Z",
    fill: "#404249",
    fillOpacity: 0.858824,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280 0H1152V128H1280M1280 0V128M1280 0H1408M1280 128H1408M1408 0V128M1408 0H1536M1408 128H1536M1536 0V128M1536 0H1664V128H1536",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 128H128V255.999H0V128Z",
    fill: "#404249",
    fillOpacity: 0.811765,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.999 128H255.999V255.999H127.999V128ZM383.999 128H511.999V255.999H383.999V128Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.999 128H639.999V255.999H511.999V128Z",
    fill: "#404249",
    fillOpacity: 0.0313726,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.001 128H640.001V255.999H768.001M768.001 128V255.999M768.001 128H896M768.001 255.999H896M896 128V255.999M896 128H1024M896 255.999H1024M1024 128V255.999M1024 128H1152V255.999H1024",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152 128H1280V255.999H1152V128Z",
    fill: "#404249",
    fillOpacity: 0.454902,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1408 128H1536V255.999H1408V128Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1536 128H1664V255.999H1536V128Z",
    fill: "#404249",
    fillOpacity: 0.388235,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 256H128V384H0V256Z",
    fill: "#404249",
    fillOpacity: 0.956863,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.999 256H256V384H383.999M383.999 256V384M383.999 256H511.999M383.999 384H511.999M511.999 256V384M511.999 256H639.999M511.999 384H639.999M639.999 256V384M639.999 256H767.999V384H639.999M127.999 256H255.999V384H127.999V256Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768 256H896V384H768V256Z",
    fill: "#404249",
    fillOpacity: 0.968627,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.999 256H1024V384H895.999V256Z",
    fill: "#404249",
    fillOpacity: 0.866667,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152 256H1024V384H1152M1152 256V384M1152 256H1280M1152 384H1280M1280 256V384M1280 256H1408V384H1280",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1408 256H1536V384H1408V256Z",
    fill: "#404249",
    fillOpacity: 0.870588,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1664 256H1536V384H1664M1664 256V384M1664 256H1792M1664 384H1792M1792 256V384M1792 256H1920V384H1792",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 384H128V512H0V384Z",
    fill: "#404249",
    fillOpacity: 0.380392,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.999 384H255.999V512H127.999V384Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.001 384H384.001V512H256.001V384Z",
    fill: "#404249",
    fillOpacity: 0.156863,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 384H384V512H512M512 384V512M512 384H639.999V512H512M1024 384H1152V512H1024V384Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152 384H1280V512H1152V384Z",
    fill: "#404249",
    fillOpacity: 0.368627,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1408 384H1280V512H1408M1408 384V512M1408 384H1536M1408 512H1536M1536 384V512M1536 384H1664M1536 512H1664M1664 384V512M1664 384H1792V512H1664M128 512H0V639.999H128M128 512V639.999M128 512H255.999V639.999H128",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.001 512H384.001V639.999H256.001V512Z",
    fill: "#404249",
    fillOpacity: 0.682353,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 512H512V639.999H384V512Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.999 512H639.999V639.999H511.999V512Z",
    fill: "#404249",
    fillOpacity: 0.45098,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.001 512H640.001V639.999H768.001M768.001 512V639.999M768.001 512H896M768.001 639.999H896M896 512V639.999M896 512H1024V639.999H896M1280 512H1152V639.999H1280M1280 512V639.999M1280 512H1408M1280 639.999H1408M1408 512V639.999M1408 512H1536M1408 639.999H1536M1536 512V639.999M1536 512H1664V639.999H1536",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1792 512H1920V639.999H1792V512ZM0 640H128V768H0V640ZM256 640H384V768H256V640Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 640H512V768H384V640Z",
    fill: "#404249",
    fillOpacity: 0.92549,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.999 640H511.999V768H639.999M639.999 640V768M639.999 640H767.999V768H639.999",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768 640H896V768H768V640Z",
    fill: "#404249",
    fillOpacity: 0.176471,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024 640H896V768H1024M1024 640V768M1024 640H1152M1024 768H1152M1152 640V768M1152 640H1280M1152 768H1280M1280 640V768M1280 640H1408M1280 768H1408M1408 640V768M1408 640H1536M1408 768H1536M1536 640V768M1536 640H1664M1536 768H1664M1664 640V768M1664 640H1792V768H1664M128 768H0V896H128M128 768V896M128 768H255.999V896H128M384 768H256V896H384M384 768V896M384 768H512V896H384",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.999 768H639.999V896H511.999V768Z",
    fill: "#404249",
    fillOpacity: 0.478431,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.001 768H640.001V896H768.001M768.001 768V896M768.001 768H896M768.001 896H896M896 768V896M896 768H1024V896H896",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024 768H1152V896H1024V768Z",
    fill: "#404249",
    fillOpacity: 0.419608,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152 768H1280V896H1152V768Z",
    fill: "#404249",
    fillOpacity: 0.282353,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280 768H1408V896H1280V768Z",
    fill: "#404249",
    fillOpacity: 0.215686,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1536 768H1408V896H1536M1536 768V896M1536 768H1664V896H1536",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 896H0V1024H128M128 896V1024M128 896H255.999V1024H128M384 896H256V1024H384M384 896V1024M384 896H512M384 1024H512M512 896V1024M512 896H639.999M512 1024H639.999M639.999 896V1024M639.999 896H768V1024H639.999M896 896H1024V1024H896V896Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024 896H1152V1024H1024V896Z",
    fill: "#404249",
    fillOpacity: 0.529412,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152 896H1280V1024H1152V896Z",
    fill: "#404249",
    fillOpacity: 0.411765,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1408 896H1280V1024H1408M1408 896V1024M1408 896H1536V1024H1408M1664 896H1792V1024H1664V896Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1024H128V1152H0V1024Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.999 1024H255.999V1152H127.999V1024Z",
    fill: "#404249",
    fillOpacity: 0.282353,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.001 1024H384.001V1152H256.001V1024Z",
    fill: "#404249",
    fillOpacity: 0.886275,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 1024H512V1152H384V1024Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.999 1024H639.999V1152H511.999V1024Z",
    fill: "#404249",
    fillOpacity: 0.576471,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.001 1024H768.001V1152H640.001V1024Z",
    fill: "#404249",
    fillOpacity: 0.356863,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768 1024H896V1152H768V1024Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.999 1024H1024V1152H895.999V1024Z",
    fill: "#404249",
    fillOpacity: 0.996078,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024 1024H1152V1152H1024V1024Z",
    fill: "#404249",
    fillOpacity: 0.756863,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152 1024H1280V1152H1152V1024Z",
    fill: "#404249",
    fillOpacity: 0.921569,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1408 1024H1280V1152H1408M1408 1024V1152M1408 1024H1536V1152H1408M1792 1024H1664V1152H1792M1792 1024V1152M1792 1024H1920V1152H1792M128 1152H0V1280H128M128 1152V1280M128 1152H255.999V1280H128",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.001 1152H384.001V1280H256.001V1152Z",
    fill: "#404249",
    fillOpacity: 0.160784,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 1152H512V1280H384V1152Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.999 1152H639.999V1280H511.999V1152Z",
    fill: "#404249",
    fillOpacity: 0.972549,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152 1152H1024V1280H1152M1152 1152V1280M1152 1152H1280M1152 1280H1280M1280 1152V1280M1280 1152H1408V1280H1280M768 1152H896V1280H768V1152Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1408 1152H1536V1280H1408V1152Z",
    fill: "#404249",
    fillOpacity: 0.423529,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1536 1152H1664V1280H1536V1152Z",
    fill: "#404249",
    fillOpacity: 0.313726,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1280H128V1408H0V1280Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.999 1280H255.999V1408H127.999V1280Z",
    fill: "#404249",
    fillOpacity: 0.109804,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 1280H384V1408H512M512 1280V1408M512 1280H639.999M512 1408H639.999M639.999 1280V1408M639.999 1280H768V1408H639.999",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.999 1280H1024V1408H895.999V1280Z",
    fill: "#404249",
    fillOpacity: 0.298039,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1408 1280H1536V1408H1408V1280Z",
    fill: "#404249",
    fillOpacity: 0.921569,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1664 1280H1536V1408H1664M1664 1280V1408M1664 1280H1792M1664 1408H1792M1792 1280V1408M1792 1280H1920V1408H1792",
    stroke: "#404249",
    strokeWidth: 0.576
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_612_858",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(960 672) scale(960 672)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.946
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_612_858"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1540,
    height: 1344,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundsquares3Install);
export default __webpack_public_path__ + "static/media/backgroundsquares3-Install.6dc0dcb36f5f659122c33a2a9e37b6a9.svg";
export { ForwardRef as ReactComponent };